module.exports = __webpack_public_path__ + "img/logo20201123.d51ba076.png";